/*
 * Define a page to prompt the user for case worker information.
 */
import * as yup from 'yup'
import css from '../../../ComplaintForm/ComplaintForm.module.css'
import { choicePage } from '../../../../pages'
import { Divider } from '../../../../components/divider'
import {
  firstNameLabel,
  lastNameLabel,
  middleNameLabel,
  optionalLabel,
  suffixLabel,
  emailLabel,
  phoneLabel
} from '../../../../strings/labels'
import {
  firstNameMessage,
  firstNameLengthMessage,
  lastNameMessage,
  lastNameLengthMessage,
  middleNameMessage,
  middleNameLengthMessage,
  workPhoneMessage,
  emailMessage,
  emailLengthMessage
} from '../../../../strings/messages'
import { alphaRegex, phoneRegex } from '../../../../strings/regex'
import React from 'react'
import { selectionRequired } from '../../../../validators'
import { suffixes } from '../../../../choices'

const CaseWorkerHeading = () => (
  <h2 className="ds-u-margin-bottom--0">Case worker</h2>
)

const ContactInformationHeading = () => (
  <h2 className="ds-u-margin-bottom--0">Contact information</h2>
)

export const caseWorkerPage = propOverrides => {
  const yes = 'Yes'
  const no = 'No'
  const props = {
    pageId: 'case_worker',
    fieldName: 'case_worker_assigned_yn',
    choices: [{ label: yes, value: yes }, { label: no, value: no }],
    conditionalValue: yes,
    className: css.choices,
    labelClassName: css.largeLabel,
    label: 'Is there an assigned state/local/tribal case worker?',
    ...propOverrides
  }

  const validation = yup.object().shape({
    [props.fieldName]: selectionRequired(),
    case_worker_first_name: yup
      .string()
      .matches(alphaRegex, {
        message: firstNameMessage,
        excludeEmptyString: false
      })
      .max(30, firstNameLengthMessage),
    otherwise: yup.string(),
    case_worker_middle_name: yup
      .string()
      .matches(alphaRegex, {
        message: middleNameMessage,
        excludeEmptyString: false
      })
      .max(30, middleNameLengthMessage),
    otherwise: yup.string(),
    case_worker_last_name: yup
      .string()
      .matches(alphaRegex, {
        message: lastNameMessage,
        excludeEmptyString: false
      })
      .max(30, lastNameLengthMessage),
    otherwise: yup.string(),
    case_worker_phone: yup.string().matches(phoneRegex, {
      message: workPhoneMessage,
      excludeEmptyString: false
    }),
    otherwise: yup.string(),
    case_worker_email: yup
      .string()
      .email(emailMessage)
      .max(250, emailLengthMessage),
    otherwise: yup.string()
  })

  const conditionals = [
    {
      value: props.conditionalValue,
      fields: [
        {
          type: 'content',
          content: CaseWorkerHeading,
          name: 'case_worker_details'
        },
        {
          type: 'text',
          label: firstNameLabel,
          name: 'case_worker_first_name',
          requirementLabel: optionalLabel
        },
        {
          type: 'text',
          label: middleNameLabel,
          name: 'case_worker_middle_name',
          requirementLabel: optionalLabel
        },
        {
          type: 'text',
          label: lastNameLabel,
          name: 'case_worker_last_name',
          requirementLabel: optionalLabel
        },
        {
          type: 'select',
          label: suffixLabel,
          name: 'case_worker_suffix',
          choices: [
            {
              value: '',
              label: ''
            },
            ...suffixes()
          ],
          requirementLabel: optionalLabel
        },
        {
          type: 'content',
          content: Divider,
          name: 'divider1'
        },
        {
          type: 'content',
          content: ContactInformationHeading,
          name: 'contact_information'
        },
        {
          type: 'text',
          label: phoneLabel,
          name: 'case_worker_phone',
          requirementLabel: optionalLabel
        },
        {
          type: 'text',
          label: emailLabel,
          name: 'case_worker_email',
          requirementLabel: optionalLabel
        }
      ]
    }
  ]

  return choicePage({ validation, conditionals, ...props })
}
